import React from 'react';
import { useTranslation } from 'react-i18next';
import { RelanceListPage } from '../../features/relance/RelanceListPage';
import { useRelanceAgendaEntries } from '../../hooks/useRelanceAgendaEntries';
import { TranslationKey } from '../../i18n/translationKeys';

const TEST_IDS = {
    title: 'ignored-relances-title',
    noAccess: 'ignored-relances-no-access',
    error: 'ignored-relances-error',
    empty: 'home-empty-ignorees',
    list: 'ignored-relances-list',
};

export const IgnoredRelances: React.FC = () => {
    const { t } = useTranslation();
    const { ignored } = useRelanceAgendaEntries();

    return (
        <RelanceListPage
            title={t(TranslationKey.IgnoredRelances.Title)}
            emptyText={t(TranslationKey.Home.Deactivated.Empty.Ignorees)}
            entries={ignored}
            testIds={TEST_IDS}
        />
    );
};
